import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationFundraisingDonationCreated.vue";

export const selector = (item: Notification): boolean => {
  return item.type === NotificationType.FUNDRAISING_GOAL_DONATION_CREATED;
};
